import { calculateIrrigationDetails } from "./irrigation";
import { FertilizerProduct } from "@/types/products";
import { IrrigationSystem } from "@/types/irrigationSystem";
import { Fertilizer } from "@/types/fertilizer";

export function targetRateNToProdutcRate(
    target_rate_n?: number,
    selectedProduct?: FertilizerProduct | Fertilizer,
) {
    if (!selectedProduct || target_rate_n == undefined || target_rate_n == null)
        return;

    let productRate;
    if (selectedProduct.fertilizer_type == 1) {
        if (selectedProduct.name == "NH3") {
            productRate = target_rate_n / 1;
        } else {
            productRate = target_rate_n / (selectedProduct.percent_N / 100);
        }
    } else if (selectedProduct.fertilizer_type == 2) {
        productRate =
            target_rate_n / parseFloat(selectedProduct.lbs_N_per_gallon?.toString());
    }
    return productRate;
}

export function productRateToTargetRateN(
    productRate?: number,
    selectedProduct?: FertilizerProduct | Fertilizer,
) {
    if (!selectedProduct || productRate == undefined || productRate == null)
        return;
    let targetRate;
    if (selectedProduct.fertilizer_type === 1) {
        if (selectedProduct.name === "NH3") {
            targetRate = productRate * 1;
        } else {
            targetRate = productRate * (selectedProduct.percent_N / 100);
        }
    } else if (selectedProduct.fertilizer_type === 2) {
        targetRate = productRate * parseFloat(selectedProduct.lbs_N_per_gallon?.toString());
    }
    return targetRate;
}

export function speedToDepth(
    speed?: number,
    irrigationSystem?: IrrigationSystem,
): number | undefined {
    if (!irrigationSystem || speed == undefined || speed == null) return;

    const depth = calculateIrrigationDetails({
        pivotSpeedPercent: speed,
        pivotMinDepth: irrigationSystem.pivot_minimum_depth,
        irrigationDepth: undefined,
    }).irrigationDepth;
    return depth ? Number(depth) : undefined;
}

export function depthToSpeed(
    depth?: number,
    irrigationSystem?: IrrigationSystem,
): number | undefined {
    if (!irrigationSystem || depth == undefined || depth == null) return;
    let speed;
    if (depth > 0) {
        speed = (
            (parseFloat(irrigationSystem.pivot_minimum_depth?.toString()) /
                depth) *
            100
        ).toFixed(2);
    } else {
        speed = 0.0;
    }
    return speed ? Number(speed) : undefined;
}

export const calculateInjectionRate = ({
    nRateGalsPerAcre = 0,
    irrigatedArea = 0,
    pivotMinRevTime = 0,
    pivotSpeedAsPercent = 0,
    precision = 0,
}: {
    nRateGalsPerAcre?: number;
    irrigatedArea?: number;
    pivotMinRevTime?: number;
    pivotSpeedAsPercent?: number;
    precision?: number;
}): string => {
    const numsAfterDecimal: number = precision >= 0 ? precision : 2;

    const emptyNum = 0;
    let rateCalculation: string = emptyNum.toFixed(numsAfterDecimal);

    if (
        pivotMinRevTime > 0 &&
        pivotSpeedAsPercent > 0 &&
        nRateGalsPerAcre > 0 &&
        irrigatedArea > 0
    ) {
        rateCalculation = (
            nRateGalsPerAcre *
            (irrigatedArea / (pivotMinRevTime / (pivotSpeedAsPercent / 100)))
        ).toFixed(numsAfterDecimal);
    }

    return rateCalculation;
};
